import Vue from "vue";
import Vuex from "vuex";
import sidebar from "./modules/sidebar";
import header from "./modules/header";
import footer from "./modules/footer";
import translation from "./modules/translation";
import notifications from "./modules/notifications";
import user from "./modules/user";
import theme from "./modules/theme";
import loader from "./modules/loader"
import defs from "./modules/defs"

import VuexPersistence from 'vuex-persist'
import SecureLS from "secure-ls"

const secureLS = new SecureLS({ isCompression: false });

const storage = {
  getItem: (key) => secureLS.get(key),
  setItem: (key, value) => secureLS.set(key, value),
  removeItem: (key) => secureLS.remove(key),
}

const vuexLocal = new VuexPersistence({
  key: 'user',
  storage,
  reducer: state => ({
    user: state.user,
    defs: state.defs,
  })
})


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    navigations: {
      namespaced: true,
      modules: {
        header,
        sidebar,
        footer,
      },
    },
    scheme: {
      namespaced: true,
      modules: {
        theme,
      },
    },
    user,
    translation,
    notifications,
    loader,
    defs
  },
    plugins: [vuexLocal.plugin]
});
